module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('x-header', [_vm._v("经销商申请")]), _vm._v(" "), _c('div', [_c('flow', [_c('flow-state', {
    attrs: {
      "state": "1",
      "title": "填写信息",
      "is-done": ""
    }
  }), _vm._v(" "), _c('flow-line'), _vm._v(" "), _c('flow-state', {
    attrs: {
      "state": "2",
      "title": "完成支付"
    }
  }), _vm._v(" "), _c('flow-line'), _vm._v(" "), _c('flow-state', {
    attrs: {
      "state": "3",
      "title": "完成"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "title": "1. 下载经销商合同并打印签字"
    }
  }, [_c('x-button', {
    nativeOn: {
      "click": function($event) {
        _vm.download()
      }
    }
  }, [_vm._v("点击下载合同")])], 1), _vm._v(" "), _c('group', {
    attrs: {
      "title": "2. 填写个人信息"
    }
  }, [_c('x-input', {
    attrs: {
      "title": "真实姓名",
      "placeholder": "填写身份证姓名",
      "placeholder-align": "right"
    },
    model: {
      value: (_vm.formData['name']),
      callback: function($$v) {
        _vm.$set(_vm.formData, 'name', $$v)
      },
      expression: "formData['name']"
    }
  }), _vm._v(" "), _c('x-input', {
    attrs: {
      "title": "身份证号",
      "placeholder": "身份证号码",
      "placeholder-align": "right"
    },
    model: {
      value: (_vm.formData['no']),
      callback: function($$v) {
        _vm.$set(_vm.formData, 'no', $$v)
      },
      expression: "formData['no']"
    }
  }), _vm._v(" "), _c('x-address', {
    attrs: {
      "title": "申请区域",
      "list": _vm.addressData,
      "placeholder": "选择要代理的区域",
      "popup-style": {
        zIndex: 502
      }
    },
    model: {
      value: (_vm.formData['pcr']),
      callback: function($$v) {
        _vm.$set(_vm.formData, 'pcr', $$v)
      },
      expression: "formData['pcr']"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "title": "3. 上传身份证(正反面)"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('uploader', {
    attrs: {
      "multiple": "",
      "max-count": 2
    },
    model: {
      value: (_vm.idCard),
      callback: function($$v) {
        _vm.idCard = $$v
      },
      expression: "idCard"
    }
  })], 1)]), _vm._v(" "), _c('group', {
    attrs: {
      "title": "4. 上传签字后的合同页"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('uploader', {
    attrs: {
      "multiple": "",
      "max-count": 9
    },
    model: {
      value: (_vm.contract),
      callback: function($$v) {
        _vm.contract = $$v
      },
      expression: "contract"
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "40px",
      "padding": "10px"
    }
  }, [_c('x-button', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.next()
      }
    }
  }, [_vm._v("下一步")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21e915ca"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sellerRequest/step1.vue
// module id = 656
// module chunks = 0